import { render, staticRenderFns } from "./UpcomingPayroll.vue?vue&type=template&id=6d47126a&scoped=true"
import script from "./UpcomingPayroll.vue?vue&type=script&lang=ts"
export * from "./UpcomingPayroll.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingPayroll.vue?vue&type=style&index=0&id=6d47126a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d47126a",
  null
  
)

export default component.exports